import { BinIcon } from '../components/photos/constants';
import toast from 'react-hot-toast';
import { useRemoveVideo } from '../hooks/useRemoveVideo';
import { UploadStatus, useVideoUploadStatus } from 'services/listerUploadVehicle/v2';
import { useFormVehicleId } from '../hooks/useFormVehicleId';
import AutoPlayVideo from 'components/AutoPlayVideo';
import styled from 'styled-components';

const Wrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  grid-column: 1 / span 2;

  & > video {
    width: 100%;
    height: 100%;
  }
`;

const DeleteWrapper = styled.div`
  position: absolute;
  top: 8px;
  left: 8px;
  display: flex;
`;

export const VideoComponent = ({ url, sectionId }: { url: string; sectionId: string }) => {
  const removeVideo = useRemoveVideo(sectionId);

  const vehicleId = useFormVehicleId();
  const uploadStatus = useVideoUploadStatus(vehicleId);

  const deleteDisabled = uploadStatus === UploadStatus.IN_PROGRESS || uploadStatus === UploadStatus.QUEUED;

  const handleRemove = async (e: any) => {
    e?.stopPropagation();
    try {
      await removeVideo();
    } catch (error) {
      toast.error(`Failed to remove video`);
    }
  };

  return (
    <Wrapper>
      <AutoPlayVideo src={url} />
      {!deleteDisabled && (
        <DeleteWrapper onClick={handleRemove}>
          <BinIcon />
        </DeleteWrapper>
      )}
    </Wrapper>
  );
};
